import { SubscriptionWidget } from '@/widgets/settings'

export const SubscriptionPage = () => {
    return <SubscriptionWidget />
}
